<template>
  <section class="main-content">
    <script type="application/ld+json">
      {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": [{
          "@type": "ListItem",
          "position": 1,
          "name": "Startseite - ito consult GmbH",
          "item": "https://ito-consult.de"
        },{
          "@type": "ListItem",
          "position": 2,
          "name": "AGB der ito consult GmbH",
          "item": "https://ito-consult.de/agb"
        }]
      }
    </script>
    <section class="block-content mb-5">
        <div class="container my-5 py-5">
            <div id="agb">
                <article class="d-content" v-html="content"></article>
            </div>
        </div>
    </section>
  </section>
</template>

<script>

import axios from 'axios'
import store from '@/store'

export default {
  name: 'Policy',
  data: function () {
    return {
      content: null
    }
  },

  async beforeMount () {
    await axios.get('/content?fields=*.*&filter[title]=AGB')
      .then(response => (this.content = response.data.data[0].content))
  },
  mounted () {
    store.commit('loadingStatus', false)
  }

}
</script>
